import { colors, logo } from "@mm/shared";

/** Full "Modern Motherhood Chicago" logo, drawn from the shared vector paths. */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox={logo.lockupViewBox} className={className} role="img" aria-label="Modern Motherhood Chicago">
      <g transform={logo.markTransform}>
        <path fill={colors.logoRose} fillRule="evenodd" d={logo.rose} />
        <path fill={colors.logoInk} fillRule="evenodd" d={logo.ink} />
      </g>
      <path fill={colors.logoInk} d={logo.wordmark} />
    </svg>
  );
}
